
class AreasCreator {

    constructor(map, buttonCreateBuffer, callbacks = {}) {
        /**
         * Promień bufora w metrach i stopień uproszczenia wynikowego polygonu w nie wiem czym
         */
        this.map = map;
        this._BUFFER_RADIUS = 50;
        this._SIMPLIFY_FACTOR = 2;

        this.buttonCreateBuffer = buttonCreateBuffer;

        this.route = null;
        this.geoJSONArea = null;
        this.callbacks = callbacks;
        this.mapElements = [];
        this.initButton();
    }

    setBufferRadius(radius) {
        this._BUFFER_RADIUS = parseInt(radius);
        console.log('setBufferRadius', this._BUFFER_RADIUS);
        if (this.route) {
            this.removeMapElements();
            this.makeZone();
        }
    }

    setRouteGeoJSON(geojson) {
        if (geojson && geojson.type == 'LineString') {
            this.route = geojson;
            return true;
        } else {
            return false;
        }
    }

    getRouteGeoJSON() {
        return this.route;
    }

    getGeoJSONArea() {
        return this.geoJSONArea;
    }

    /*
 * Funkcja uruchamiana po inicjalizacji mapy, tworzy przycisk, który wywołuje akcję wyznaczenia strefy dla aktualnej trasy;
 * Dzięki obsłudze zdarzeń modułu trasy przycisk jest widoczny tylko wtedy, gdy trasa jest wyznaczona
 */
    initButton() {
        console.log('AreasCreator(), initButton()');
        // let button = document.createElement('button');
        // button.innerHTML = 'Wyznacz strefę z trasy';
        // button.style.cssText = 'position: absolute; top: 10px; right: 100px; display: block; z-index: 1000;';
        if (this.buttonCreateBuffer) {
            this.buttonCreateBuffer.addEventListener('click', () => {
                console.log('AreasCreator(), AreasCreator.initButton() click');
                // this.blockRoute.bind(this);
                this.blockRoute();
            });
        } else {
            console.warn('AreasCreator(), Not found buttonCreateBuffer');
        }
        if (typeof this.callbacks['onRouteFound'] === 'function') {
            this.map.modules.FindRoute.listen('onRouteFound', this.callbacks['onRouteFound']);
        } else {
            console.warn('AreasCreator(), Not found onRouteFound callback');
        }
        if (typeof this.callbacks['onRouteRemoved'] === 'function') {
            this.map.modules.FindRoute.listen('onRouteRemoved', this.callbacks['onRouteRemoved']);
        } else {
            console.warn('AreasCreator(), Not found onRouteRemoved callback');
        }
        // document.body.appendChild(button);
        // console.log('AreasCreator.initButton()', button);
    }


    /*
     * Funkcja modyfikująca dostępne opcje trasy poprzez dodanie na początku opcji "utwórz strefę"
     * Po kliknięciu tej opcji wywołana zostanie funkcja podana we właściwości handler, czyli w tym przypadku blockRoute
     */
    setRouteOptions(route, opts) {
        opts.splice(i, 0, {
            label: 'Utwórz strefę',
            icon: Targeo.Base.getSVGSrc('<path d="M14.73,19H7.4a2.33,2.33,0,0,1-2.33-2.33V9.33A2.33,2.33,0,0,1,7.4,7h4a1,1,0,0,1,0,2h-4a.33.33,0,0,0-.33.33v7.34A.33.33,0,0,0,7.4,17h7.33a.34.34,0,0,0,.34-.33v-4a1,1,0,0,1,2,0v4A2.34,2.34,0,0,1,14.73,19Z" fill="#77b024"/><path d="M19.07,6v4a1,1,0,0,1-2,0V8.41L11.44,14A1,1,0,0,1,10,14a1,1,0,0,1,0-1.41L15.65,7H14.07a1,1,0,0,1,0-2h4a1,1,0,0,1,.71.29A1,1,0,0,1,19.07,6Z" fill="#77b024"/>', 24, 24),
            active: true,
            handler: this.blockRoute.bind(this)
        });
    }

    /*
     * Funkcja uruchamia standardową RPC mapy, której zadaniem jest skopiowanie danych trasy z lokalnego mongo do mastera, żeby aplikacja nie musiała szukać tych danych po różnych serwerach.
     * Po wykonaniu RPC uruchamiana jest funkcja getCourse.
     */
    blockRoute() {
        console.log('AreasCreator.blockRoute()');
        let route = this.map.modules.FindRoute.getRoute();
        fetch(_TARGEO_GLOBALS.url + 'service.html?rpc=RouteBlock&id=' + route.id + '&r=telematics&e=' + encodeURIComponent('+5 minutes') + '&' + _TARGEO_GLOBALS.urlParams, { credentials: 'include' })
            .then((response) => response.json())
            .then((data) => this.getCourse(data.id));
    }

    /*
     * Funkcja wywołuje RPC getcourse.php zwracającą najmniej uproszczony przebieg trasy w postaci tablicy segmentów, w której każdy segment to tablica współrzędnych [x1,y1,x2,y2...].
     * Po wykonaniu RPC uruchamiana jest funkcja makeZone.
     */
    getCourse(rid) {
        console.log('AreasCreator.getCourse()', rid);
        fetch('./scripts/telematics-get-course.php?id=' + rid, { credentials: 'include' })
            .then((response) => response.json())
            .then((data) => {
                this.route = this.makeRouteGeoJSON(data.route);
                this.makeZone();
            });
    }


    makeRouteGeoJSON(course) {
        let i, ii, j, jj, k, kk;
        let linestring = [];
        for (i = 0, ii = course.length; i < ii; i++) {
            for (j = 0, jj = course[i].length; j < jj; j++) {
                for (k = 0, kk = course[i][j].length; k < kk; k += 2) {
                    linestring.push([parseFloat(course[i][j][k]), parseFloat(course[i][j][k+1])]);
                }
            }
        }
        return {type: 'LineString', coordinates: linestring};
    }

    makeZone() {
        console.log('AreasCreator.makeZone(), course', this.route);
        console.log('AreasCreator.makeZone(), this._BUFFER_RADIUS', this._BUFFER_RADIUS);
        let course = this.route.coordinates;
        this.geoJSONArea = this.makeZoneGeoJSON(course, this._BUFFER_RADIUS);
        let mapElement = this.getMapElement({geometry: this.geoJSONArea});
        this.addMapElement(mapElement);
        console.log('this', this);
        if (typeof this.callbacks['onBufferCreate'] === 'function') {
            this.callbacks['onBufferCreate']();
        }
    }

    makeZoneGeoJSON(course, buffer) {
        let i, ii, c, jstsobj, polygon, holes;
        let linestring = [];
        for (i = 0, ii = course.length; i < ii; i++) {
            c = proj4('EPSG:4326', 'EPSG:2180', { x: course[i][0], y: course[i][1] });
            linestring.push(new jsts.geom.Coordinate(c.x, c.y));
        }
        jstsobj = (new jsts.geom.GeometryFactory()).createLineString(linestring);
        jstsobj = jstsobj.buffer(buffer, this._SIMPLIFY_FACTOR);
        polygon = [jstsobj.getExteriorRing().getCoordinates().map(function (c) { c = proj4('EPSG:2180', 'EPSG:4326', c); return [parseFloat(c.x.toFixed(6)), parseFloat(c.y.toFixed(6))] })];
        holes = jstsobj.getNumInteriorRing();
        for (i = 0, ii = holes; i < ii; i++) {
            polygon.push(jstsobj.getInteriorRingN(i).getCoordinates().map(function (c) { c = proj4('EPSG:2180', 'EPSG:4326', c); return [parseFloat(c.x.toFixed(6)), parseFloat(c.y.toFixed(6))] }));
        }
        return { type: 'Polygon', coordinates: polygon };
    }

    getMapElement(zone) {
        let geometry = JSON.parse(JSON.stringify(zone.geometry));
        switch (geometry.type) {
            case 'Point':
                return new Targeo.MapObject.Oval({x: geometry.coordinates[0], y: geometry.coordinates[1]}, zone.buffer, null, { units: 'm', strokeWidth: 3, strokeColor: '#5e9dd3', fillColor: '#ffffff77', interactive: false });
                break;
            case 'LineString':
                geometry = this.makeZoneGeoJSON(geometry.coordinates, zone.buffer);
            case 'Polygon':
                return new Targeo.MapObject.Polyline(geometry.coordinates, {closed: true, drawStyle: [{strokeWeight: '6px', strokeColor: '#ffffff', strokeOpacity: '0.8', fill: '#ffffff77'}, {strokeWeight: '3px', strokeColor: '#5e9dd3', strokeOpacity: '1'}]});
        }

    }

    addMapElement(mapElement) {
        this.mapElements.push(mapElement);
        this.map.UOAdd(mapElement);
    }

    zoomToMapElement(zone) {
        let geometry = JSON.parse(JSON.stringify(zone.geometry));
        switch (zone.geometry.type) {
            case 'Point':
                let mapres = this.map.getResolution();
                let mapsize = this.map.getSize();
                let zoomin = 0;
                if (Math.min(mapsize[0], mapsize[1]) * mapres > 10 * zone.buffer) {
                    while (Math.min(mapsize[0], mapsize[1]) * mapres > 10 * zone.buffer) {
                        mapres /= 2;
                        zoomin++;
                    }
                } else if (Math.min(mapsize[0], mapsize[1]) * mapres < 4 * zone.buffer) {
                    while (Math.min(mapsize[0], mapsize[1]) * mapres < 4 * zone.buffer) {
                        mapres *= 2;
                        zoomin--;
                    }
                }
                this.map.zoomAndCenter({x: geometry.coordinates[0], y: geometry.coordinates[1]}, this.map.getZoom() - zoomin);
                break;
            case 'LineString':
                geometry = this.makeZoneGeoJSON(zone.geometry.coordinates, zone.buffer);
            case 'Polygon':
                let ring = geometry.coordinates[0];
                let bounds = {minX: ring[0][0], maxX: ring[0][0], minY: ring[0][1], maxY: ring[0][1]};
                for (let i = 1, ii = ring.length; i < ii; i++) {
                    bounds.minX = Math.min(bounds.minX, ring[i][0]);
                    bounds.maxX = Math.max(bounds.maxX, ring[i][0]);
                    bounds.minY = Math.min(bounds.minY, ring[i][1]);
                    bounds.maxY = Math.max(bounds.maxY, ring[i][1]);
                }
                this.map.zoomToBounds(bounds, true, 30);
                break;
        }
    }

    removeMapElements() {
        this.mapElements.forEach((el) => this.map.UORemove(el.id));
        this.mapElements = [];
    }

}


export default AreasCreator;
